<div class="menu-sce-logs">
	<div>
		<lua-list-item class="list-item" [text]="sceDebug ? 'Désactiver' : 'Activer'" iconColor="CouleurPrimaire" iconName="bug_report"
			(click)="handleActiveDebug($event)"></lua-list-item>
		<lua-list-item class="list-item" text="Télécharger" iconName="download" (click)="handleDownloadLogsClick($event)"
			iconColor="CouleurPrimaire"></lua-list-item>
		<lua-divider-horizontal></lua-divider-horizontal>
		<lua-list-item class="list-item" text="Supprimer" iconName="delete" iconColor="Error"
			(click)="handleSupprimerClick($event)" ></lua-list-item>
	</div>
</div>